import { render, staticRenderFns } from "./ChatWrap.vue?vue&type=template&id=fe6de362&scoped=true&"
import script from "./ChatWrap.vue?vue&type=script&lang=js&"
export * from "./ChatWrap.vue?vue&type=script&lang=js&"
import style0 from "./ChatWrap.vue?vue&type=style&index=0&id=fe6de362&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe6de362",
  null
  
)

export default component.exports